// extracted by mini-css-extract-plugin
export default {"primaryColor":"#128480","errorColor":"#d11515"};